// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Selectable from 'components/focus/Selectable';

import playIcon from 'assets/images/heroCta.svg';

import styles from './CarouselButton.module.scss';

const Button = ({
  children,
  className,
  hasInitialFocus,
  focusId,
  onClick,
  onFocusSet,
  ttsText,
  showPlayIcon,
  ...rest
}) => {
  return (
    <Selectable
      onSelect={onClick}
      hasInitialFocus={hasInitialFocus}
      focusId={focusId}
      onFocusSet={onFocusSet}
      ttsText={ttsText}
      render={({ hasFocus }) => (
        <button
          type="button"
          className={classNames(
            styles.button,
            className,
            hasFocus ? styles.focused : styles.unfocused,
          )}
          onClick={onClick}
          {...rest}
        >
          {showPlayIcon && <img src={playIcon} alt="" />} {children}
        </button>
      )}
    />
  );
};

Button.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  hasInitialFocus: PropTypes.bool,
  focusId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  children: PropTypes.node.isRequired,
  onFocusSet: PropTypes.func,
  ttsText: PropTypes.string.isRequired,
  showPlayIcon: PropTypes.bool,
};

Button.defaultProps = {
  className: null,
  hasInitialFocus: false,
  onClick: () => {},
  focusId: null,
  onFocusSet: () => {},
  showPlayIcon: true,
};

export default React.memo(Button);
